import { type ReactNode, StrictMode } from 'react';

import ThemeProvider from '@app/components/ThemeProvider';
import { appQueryClient } from '@app/externalApi/appQueryClient';
import { QueryClientProvider } from '@tanstack/react-query';

interface RootProvidersProps {
    isDarkmode?: boolean;
    children: ReactNode;
}

const RootProviders = ({ children, isDarkmode = false }: RootProvidersProps) => (
    <StrictMode>
        <ThemeProvider isDarkmode={isDarkmode}>
            <QueryClientProvider client={appQueryClient}>{children}</QueryClientProvider>
        </ThemeProvider>
    </StrictMode>
);

export default RootProviders;
